import { FormikHelpers } from "formik";
import { postForm } from "../api/util";
import { DEFAULT_ERROR, VEDHAEFTELSE_MISSING_ERROR } from "../constants/errors";

interface Email {
  ids: string[];
  indhold: string;
  afsenderEmailAdresse: string;
  afsenderFuldtNavn: string;
  signatur: string;
  emne: string;
  vedhaeftelser: (IVedhaeftelse | File)[];
  additionalRecipients?: additionalRecipient;
}
const base64ToBlob = async (base64: string, mimeType: string) => {
  const response = await fetch(`data:${mimeType};base64,${base64}`);
  return response.blob();
};

export const convertEmailTypeToForm = (type: IEmailTypes): IEmailFormTypes => {
  switch (type) {
    case "firma":
      return "Firma";
    case "fmulinje":
      return "Linje";
    case "fmuretssagsproeve":
      return "Retssagsproeve";
    case "kursus":
      return "Kursus";
    case "person":
      return "Person";
  }
};
export const convertEmailTypeFromForm = (
  type: IEmailFormTypes,
): IEmailTypes => {
  switch (type) {
    case "Firma":
      return "firma";
    case "Kursus":
      return "kursus";
    case "Linje":
      return "fmulinje";
    case "Person":
      return "person";
    case "Retssagsproeve":
      return "fmuretssagsproeve";
  }
};

const getSelectionId = (type: IEmailTypes): string => {
  switch (type) {
    case "person":
      return "PersonIds";
    case "kursus":
      return "PersonIds";
    case "firma":
      return "FirmaIds";
    case "fmulinje":
      return "PersonIds";
    case "fmuretssagsproeve":
      return "RetssagsproeveId";
  }
};

const getRetssagRecipient = (type: additionalRecipient) => {
  switch (type) {
    case "kandidat":
      return "SendTilKandidat";
    case "censor":
      return "SendTilCensor";
    case "retten":
      return "SendTilRetten";
  }
};

export const appendVedhaefeler = async (
  body: FormData,
  vedhaeftelser: (IVedhaeftelse | File)[],
) => {
  await Promise.all(
    vedhaeftelser.map(async (v) => {
      if ("dokument" in v && typeof v.dokument !== "string") {
        body.append("Vedhaeftelser", v.dokument);
      } else if ("dokument" in v && typeof v.dokument === "string") {
        const blob = await base64ToBlob(v.dokument, v.mediaType);
        const f = new File([blob], v.navn, { type: v.mediaType });
        body.append("Vedhaeftelser", f);
      } else {
        console.error(VEDHAEFTELSE_MISSING_ERROR.message);
      }
    }),
  );
};

export const sendEmails = async (
  { type, typeId }: { type: IEmailTypes; typeId: string | undefined },
  email: Email,
  actions: FormikHelpers<ISendEmailControl>,
) => {
  try {
    const body = new FormData();
    const selectionId = getSelectionId(type);
    if (typeId) {
      switch (type) {
        case "kursus":
          body.append("KursusId", typeId);
          break;
        case "fmulinje":
          body.append("FmulinjeId", typeId);
          break;
      }
    }
    email.ids.forEach((id) => {
      body.append(selectionId, id);
    });
    if (type === "fmuretssagsproeve" && email.additionalRecipients) {
      body.append(getRetssagRecipient(email.additionalRecipients), "true");
    }
    body.append("Indhold", email.indhold);
    body.append("AfsenderEmailAdresse", email.afsenderEmailAdresse);
    body.append("AfsenderFuldtNavn", email.afsenderFuldtNavn);
    body.append("Emne", email.emne);
    body.append("BrugSignatur", email.signatur);
    await appendVedhaefeler(body, email.vedhaeftelser);
    await postForm({
      query: `email/send/${type}`,
      body,
    });
    return true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    actions.setStatus(DEFAULT_ERROR.message);
    return false;
  }
};
